export default function Homepage() {
  return (
    <div>
      <h2>
        Welcome to our page!
      </h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis, modi
        accusamus. Nostrum autem et labore eveniet tempora voluptatem, eligendi
        aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis
        distinctio? Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Veritatis, modi accusamus. Nostrum autem et labore eveniet tempora
        voluptatem, eligendi aliquam, fugit ipsum nisi accusamus, itaque
        architecto nemo omnis nobis distinctio? Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Veritatis, modi accusamus. Nostrum autem et
        labore eveniet tempora voluptatem, eligendi aliquam, fugit ipsum nisi
        accusamus, itaque architecto nemo omnis nobis distinctio?
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis, modi
        accusamus. Nostrum autem et labore eveniet tempora voluptatem, eligendi
        aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis
        distinctio? Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Veritatis, modi accusamus. Nostrum autem et labore eveniet tempora
        voluptatem, eligendi aliquam, fugit ipsum nisi accusamus, itaque
        architecto nemo omnis nobis distinctio? Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Veritatis, modi accusamus. Nostrum autem et
        labore eveniet tempora voluptatem, eligendi aliquam, fugit ipsum nisi
        accusamus, itaque architecto nemo omnis nobis distinctio?
      </p>
    </div>
  );
}
